<template>
  <div class="modal-mask">
    <div class="ui small modal">
      <div class="header">{{title}}</div>
      <div class="content">
        <div class="ui warning message flex">
          <i class="exclamation circle icon"></i>
          <div class="newline message">{{message}}</div>
        </div>
      </div>
      <div class="actions">
        <div class="ui button" @click="cancel">{{cancelLabel}}</div>
        <div class="primary ui button" @click="execute">{{executeLabel}}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: String,
    message: String,
    cancelLabel: String,
    executeLabel: String,
    callback: Function
  },
  methods: {
    execute: function () {
      this.callback(true)
      this.$store.commit('confirmModal/closeModal')
    },
    cancel: function () {
      this.callback(false)
      this.$store.commit('confirmModal/closeModal')
    }
  }
}
</script>
<style scoped>
.modal-mask {
  background-color: rgba(0, 0, 0, 0.7);
  display: block;
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
}

.ui.modal {
  background-color: white;
  display: block;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.ui.message.flex {
  display: flex;
  position: relative;
}

.ui.message.flex > .icon {
  position: absolute;
  top: 50%;
  margin-top: -10px;
}

.ui.message.flex > .message {
  margin-left: 25px;
}
</style>
